'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _DeleteTestimonyModal = _interopRequireDefault(require("Modals/DeleteTestimonyModal"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
let columns = [{
  id: 'title',
  label: 'Titre',
  sortable: false
}, {
  id: 'author',
  label: 'Auteur',
  sortable: false
}, {
  id: 'type',
  label: 'Type',
  sortable: false
}, {
  id: 'actions',
  label: ''
}];
class TestimoniesDashboardPage extends _react.Component {
  state = {
    loading: false,
    openDeleteTestimonyModal: false,
    status_messages: {}
  };
  fetching = {};
  componentDidMount = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchTestimony();
  };
  fetchTestimony = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.fetching['fetchTestimony']) {
      component.fetching['fetchTestimony'].abort();
    }
    component.setState({
      loading: true
    });
    component.fetching['fetchTestimony'] = qwest.post('/testimony/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        testimonies: response.testimonies
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteTestimonyModal = ({
    testimony_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteTestimonyModal: true,
      delete_modal_testimony: testimony_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteTestimonyModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteTestimonyModal: false,
      delete_modal_testimony: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchTestimony();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const list_testimonies = (state.testimonies || []).map(function (testimony) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/contenu/liste-des-temoignages/modifier-temoignage/' + testimony.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        key: testimony._id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, testimony.title, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, testimony.author, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, testimony.type, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteTestimonyModal({
          testimony_id: testimony._id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      }))));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_Back.default, _extends({
      page_title: "T\xE9moignages"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-back-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-bottom-15 u-text-right"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: (0, _Routes.URL)('NewTestimonyPage', _Routes.front_urls),
      color: "primary",
      variant: "contained",
      size: "large",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
    }, "Ajouter un t\xE9moignage")), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Table.default, null, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: () => {},
      order: undefined,
      order_by: undefined,
      row_count: (state.testimonies || []).length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, list_testimonies)), loader))), /*#__PURE__*/_react.default.createElement(_DeleteTestimonyModal.default, {
      testimony_to_delete: state.delete_modal_testimony,
      open: state.openDeleteTestimonyModal,
      onClose: component.closeDeleteTestimonyModal,
      delete_modal_trigger: state.delete_modal_trigger
    }));
    return output;
  }
}
exports.default = TestimoniesDashboardPage;
